// extracted by mini-css-extract-plugin
export default {"description":"_2I8tt","officialDescription":"KEOJu _2I8tt","flavorText":"_23qrc _2I8tt","wishListLabel":"_3axnj","wishListTextContent":"_11WFG","loreLink":"_1apez"};